import { render } from "./previewCode.vue?vue&type=template&id=ebf2653a&scoped=true"
import script from "./previewCode.vue?vue&type=script&lang=js"
export * from "./previewCode.vue?vue&type=script&lang=js"

import "./previewCode.vue?vue&type=style&index=0&id=ebf2653a&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf2653a"]])

export default __exports__